import type { ConversationMessage } from '@/components/session/ConversationTranscript';
import type { SmartReviewSpeakerTurn } from './streamingClient';

/**
 * Convert smart review speaker turns into ConversationMessage format.
 * Extracted from conversation.tsx handleSmartReviewComplete for testability.
 */
export const convertTurnsToMessages = (turns: SmartReviewSpeakerTurn[]): ConversationMessage[] => {
  const messages: ConversationMessage[] = [];

  for (let i = 0; i < turns.length; i++) {
    const turn = turns[i];
    const baseId = turn.segment_ids.join('-');
    const id =
      turns.filter((t, j) => j < i && t.segment_ids.join('-') === baseId).length > 0
        ? `${baseId}-split-${i}`
        : turn.segment_ids[0] || `smart-${i}`;

    messages.push({
      id,
      speaker: turn.speaker === 'Læknir' ? 'doctor' : 'patient',
      text: turn.text,
      timestamp: turn.timestamp ?? 0,
      end_timestamp: turn.end_timestamp,
    });
  }

  return messages;
};

/**
 * Merge new smart review messages into existing messages.
 * Removes original messages that were replaced by smart review,
 * then appends the cleaned versions and sorts by timestamp.
 */
export const mergeSmartReviewMessages = (
  existing: ConversationMessage[],
  newMessages: ConversationMessage[],
  replacedSegmentIds?: string[]
): ConversationMessage[] => {
  const replacedSet = replacedSegmentIds ? new Set(replacedSegmentIds) : null;
  const kept = replacedSet ? existing.filter((m) => !replacedSet.has(m.id)) : existing;
  return [...kept, ...newMessages].sort((a, b) => a.timestamp - b.timestamp);
};
